const Systems ="Lotto888" 

export default Systems;
